import PremiumClient from '@st-graphics/premium'

export default {
  install (Vue) {
    const premium = new PremiumClient(process.env.NODE_ENV)
    Vue.prototype.$premium = premium
  }
}
